import { restApiClient } from '@/datasources';

export const CLEAR_CART_ROUTE = '/online/cart/clear';

export async function clearCart(): Promise<void> {
  await restApiClient.post(CLEAR_CART_ROUTE, {});
}
